document.addEventListener('DOMContentLoaded', function() {

    document.addEventListener('updateShippingBar', function() {
      const shippingBar = document.querySelector('.free-shipping-bar');
      console.log('Shipping bar update event triggered');
      if (!shippingBar) {
        console.log('No shipping bar found');
        return;
      }
  
      // Check if the bar is currently visible
      const isVisible = shippingBar.getAttribute('data-visible') === 'true';
      console.log('Current visibility:', isVisible);

      if (!isVisible) {
        // If the bar is not visible, run the entry animation
        shippingBar.setAttribute('data-visible', 'true');
        console.log('Making shipping bar visible');

        shippingBar.animate([
          { top: '-60px' },
          { top: '0' }
        ], {
          duration: 300,
          easing: 'ease-in-out',
          fill: 'forwards'
        });
      }

      // Clear any previous exit timeouts and set a new one
      clearTimeout(shippingBar.exitTimeout);
      shippingBar.exitTimeout = setTimeout(() => {
        shippingBar.setAttribute('data-visible', 'false');
        console.log('Hiding shipping bar after timeout');
        shippingBar.animate([
          { top: '0' },
          { top: '-60px' }
        ], {
          duration: 300,
          easing: 'ease-in-out',
          fill: 'forwards'
        });
      }, 8000);
    });

    console.log('Initial shipping bar update triggered');
    document.dispatchEvent(new Event('updateShippingBar'));
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.matches('.shipping-bar-section')) {
    document.dispatchEvent(new Event('updateShippingBar'));
  }
});